const radios = document.querySelectorAll(".configs__app-radio")

document.addEventListener("click", e => {
    if (e.target.matches(".configs__app-icon")) return

    radios.forEach(r => {
        r.checked = false
    })
})